import { Dropdown } from 'primereact/dropdown';
import DatePicker from 'react-multi-date-picker';
import { SkeletonContainer } from '../../../components/Loader/Loader.jsx';
import { useReports } from '../../../Hooks/Features/Reports/useReports.js';
import { useCommon } from '../../../Hooks/Common/useCommon.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PrecisionReport from '../../../components/Report/PrecisionReport.jsx';
import { MultiSelect } from 'primereact/multiselect';
import PanelHeaderTemplate from '../../../components/CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate.jsx';


export const Report = () => {
    const { listLoader, reportList, handleReport, selectedReport, html, loader, MyPlugin, handleProject, handleSprint, handleUser, hoveredRange, setHoveredRange, isChanged, setIsChanged, downloadHtmlFile, downloadPdfFile, containerRef, showPrecisionReport, handleMail, isStatic, options, filterValues, setFilterValues, verifyReport } = useReports();
    const { getValuePermission } = useCommon();


    return (
        <div>
            <div className="report-sidebar">
                {!listLoader ? <span>
                    {reportList.map((item, i) => (
                        !getValuePermission(item?.report_key) && <div onClick={() => handleReport(item)} key={item.report_id} className={`report-title c-pointer ${selectedReport.report_id == item.report_id ? 'handle' : ''}`}>{item.report_name}</div>
                    ))}
                </span> : <SkeletonContainer />
                }
            </div>
            <div className="content">
                <div className='row'>
                    <div className='col-12'>
                        {!isStatic && selectedReport?.report_name &&
                            <div className='header-filters'>
                                <div className='row'>
                                    <div className='col-6 text-left'>
                                        <h5>{selectedReport?.report_name}</h5>
                                    </div>
                                    <div className='row' style={{ width: "100%" }}>
                                        <div className='col-2'>
                                            <Dropdown placeholder='Projects' showClear filterInputAutoFocus value={filterValues?.project} options={options?.projects} onChange={(e) => { handleProject(e.value); setIsChanged(true) }} optionLabel="project_name" filter onHide={() => { isChanged && handleReport(selectedReport) }} className='sk-multiselect' />

                                        </div>
                                        <div className='col-2'>
                                            <MultiSelect placeholder="Sub Project Module" options={options?.sub_projects} optionLabel='option_value' filter filterInputAutoFocus value={filterValues?.sub_project} onChange={(e) => { setIsChanged(true); setFilterValues((prev) => ({ ...prev, sub_project: e.value })); }} onHide={() => { isChanged && handleReport(selectedReport) }} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, "sub_project", filterValues?.sub_project, () => setFilterValues((prev) => ({ ...prev, sub_project: [] })), () => handleReport(selectedReport, 'subproject'))} className='sk-multiselect' />
                                        </div>
                                        <div className='col-2'>
                                            <Dropdown placeholder='Sprints' showClear filterInputAutoFocus optionLabel="sprint_name" options={options?.sprints} value={filterValues?.sprints} onChange={(e) => { handleSprint(e.value); setIsChanged(true) }} filter onHide={() => { isChanged && handleReport(selectedReport) }} className='sk-multiselect' />

                                        </div><div className='col-2'>
                                            <Dropdown placeholder='Users' showClear filterInputAutoFocus value={filterValues?.users} optionLabel="user_display_name" options={options?.users} onChange={(e) => { handleUser(e.value); setIsChanged(true) }} filter onHide={() => { isChanged && handleReport(selectedReport) }} className='sk-multiselect' />

                                        </div>
                                        <div className='col-2'>
                                            <DatePicker
                                                value={hoveredRange}
                                                onChange={setHoveredRange}
                                                range
                                                rangeHover
                                                numberOfMonths={2}
                                                plugins={[<MyPlugin position="bottom" />]}
                                                onClose={() => handleReport(selectedReport)}
                                                placeholder='Select Date'
                                            />
                                        </div>
                                        <div className='col-2 d-flex justify-content-end gap-2'>
                                            {
                                                (filterValues?.project && hoveredRange?.length > 0) &&
                                                <>
                                                    {
                                                        filterValues?.status === "Verified" ? <button disabled className='rounded bg-success text-white'> Verified </button> : <button
                                                            className="sk-btn sk-btn-primary text-white bg-black"
                                                            onClick={() => verifyReport()}
                                                        >
                                                            Mark as Verify
                                                        </button>
                                                    }</>
                                            }

                                            <button
                                                className="sk-btn sk-btn-primary"
                                                onClick={() => handleReport(selectedReport)}
                                                title="Refresh"
                                            >
                                                <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        }
                    </div>
                </div>
                {
                    loader ?
                        <SkeletonContainer />
                        : <div>
                            {
                                html ?
                                    <div className='row'>
                                        <div className='d-flex gap-2 py-2 justify-content-end'>
                                            <button onClick={() => handleMail(html)}><FontAwesomeIcon icon="fa-solid fa-envelope" /> Mail</button>
                                            <button onClick={() => downloadPdfFile(html)}><FontAwesomeIcon icon="fa-solid fa-file-arrow-down" /> PDF</button>
                                            <button onClick={() => downloadHtmlFile(html)}><FontAwesomeIcon icon="fa-solid fa-file-arrow-down" /> HTML</button>
                                        </div>
                                        <div className='col-12 html-content' ref={containerRef}>
                                            <div dangerouslySetInnerHTML={{ __html: html }} />
                                        </div>
                                    </div>
                                    :
                                    (showPrecisionReport && isStatic &&
                                        <PrecisionReport />
                                    )
                            }
                        </div>
                }
            </div>
        </div>
    );
};

export default Report;

